module.exports = __webpack_public_path__ + "static/media/home-section-background.2ba5b9c9.jpeg";